import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import * as dateFns from 'date-fns';

import '../Filters/DateRangeSelector/SmallCalendar/SmallMonthRows/styles.scss';
import PickerCalendar from './PickerCalendar';
import { DatePickerProps } from './types';

// receives date and setDate of his parent
const DatePicker = ({ date, setDate, isCustomZone } : DatePickerProps) => {
  const [show, setShow] = useState(false); // true for show, false for no show

  const [viewDate, setViewDate] = useState(date);
  const [tempDate, setTempDate] = useState(date);


    const handleToggle = (event: boolean) => {
    if (event) {
      openPicker();
      setShow(true);
    } else {
      setShow(false);
    }
  };

  const openPicker = () => {
    if (isCustomZone) {
      setViewDate(date);
      setTempDate(date);
    }
  };

  const closePicker = () => setShow(false);

  const nextClick = () => {
    if (isCustomZone) {
      setViewDate(dateFns.addMonths(viewDate, 1));
    } else {
      setDate(dateFns.addMonths(date, 1));
    }
  };

  const previousClick = () => {
    if (isCustomZone) {
      setViewDate(dateFns.subMonths(viewDate, 1));
    } else {
      setDate(dateFns.subMonths(date, 1));
    }
  };
  
  const clickDate = (selected: Date) => {
    if (isCustomZone) {
      setTempDate(selected);
    } else {
      setDate(selected);
      setTimeout(() => setShow(false), 400);
    }
  };

  const applyDate = () => {
    setDate(new Date(tempDate)  );
    setShow(false);
  };


  return <>
    <Dropdown className="timep-00" show={show} onToggle={event =>handleToggle(event)}>
      <Dropdown.Toggle id="dropdown-basic"  className="custom-dropdown-button">
        {dateFns.format(date, 'MMM d, yyyy')}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <PickerCalendar date={isCustomZone ? viewDate : date} previousClick={previousClick} nextClick={nextClick}
                        click={clickDate} selectedDate={isCustomZone ? tempDate : date}/>
        {isCustomZone && (
          
        <div className="footer-s">
        <button className="btn-transparet" onClick={closePicker}>Cancel</button>
        <button
          className={'btn-blue'}
          onClick={applyDate}
        >
          Apply
        </button>
      </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  </>;
};

export default DatePicker;